var map = {
	"./DigiWheel_Logo_Evolution_Company.png": 6162,
	"./DigiWheel_Logo_Evolution_Company_RGB_Yellow_Black.svg": 3163,
	"./DigiWheel_Logo_Evolution_Company_RGB_Yellow_White.svg": 1521,
	"./Flapper.png": 3464,
	"./js/Winwheel": 4328,
	"./js/Winwheel.js": 4328,
	"./rule_tips.png": 8797,
	"./wheel.png": 6427
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 290;